import { Row, Col } from "../../components/RowCol";
import Carousel from "../../components/Carousel";

import styled from "styled-components";
import RateCards from "./../../components/Landing/RateCards";
import HealthArticleCard from "./../../components/Landing/HealthArticleCard";
import CovidQuery from "./../../components/Landing/CovidQuery";
import HealthQuery from "./../../components/Landing/HealthQuery";
import FaqAndTips from "./../../components/Landing/FaqAndTips";
import LiveSessionCard from "./../../components/Landing/LiveSessionCard";
import AboutUs from "./../../components/Landing/AboutUs";
import MainCarousel from "./MainCarousel";
import React, { useState } from "react";

const Home = ({ type,setSearchText }) => {
 

  const [showMoreC1, setShowMoreC1] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const getText = () => {
    // For Text that is shorter than desired length
    if (healthyFood.length <= 550) return healthyFood;
    // If text is longer than desired length & showMore is true
    if (healthyFood.length > 550 && showMore) {
      return (
        <>
          <p>{healthyFood}</p>
          <Button  onClick={() => setShowMore(false)}>Show Less</Button>
         
        </>
      );
    }
     // If text is longer than desired length & showMore is false
    if (healthyFood.length > 550) {
      return (
        <>
          <p>{healthyFood.slice(0, 550)}...</p>
          <Button  onClick={() => setShowMore(true)}>Learn More</Button>
         
        </>
      );
    }
  };
  const getFirstText = () => {
    // For Text that is shorter than desired length
    if (healthiness.length <= 750) return healthiness;
    // If text is longer than desired length & showMore is true
    if (healthiness.length > 750 && showMoreC1) {
      return (
        <>
          <p>{healthiness}</p>
          <Button  onClick={() => setShowMoreC1(false)}>Show Less</Button>
         
        </>
      );
    }
     // If text is longer than desired length & showMore is false
    if (healthiness.length > 750) {
      return (
        <>
          <p>{healthiness.slice(0, 750)}...</p>
          <Button  onClick={() => setShowMoreC1(true)}>More</Button>
         
        </>
      );
    }
  };
  return (
    <div
      // style={{
      //   width: "calc(100vw - 300px)",
      // }}
    >
      <MainCarousel type={type}  setSearchText={setSearchText}/>
      <RateCards />
     {/* <Row style={{ marginTop: "4%" }}>
        <Col area="span 6">
          <img src="/img/Group-27317.png" alt="" />
        </Col>
        <Col area="span 6">
          <img src="/img/Group-27400.png" alt="" />
        </Col>
      </Row>*/}
      <Row style={{ marginTop: "2%" }}> <Col area="span 12">
      <Carousel
        delay={15000}
        content={[
          <div
            style={{
              background: "#EFF8F7",
              height: "400px",
              //position: "relative",
            }}
          >
            <div>
              <div
                style={{
                  position: "absolute",
                  left: "10%",
                  top: 0,
                }}
              >
                <img src="/img/lifestyle.png" alt="lifestyle" height="400px" />
              </div>
              <div
                style={{
                  maxWidth: "560px",
                  position: "absolute",
                  left: "50%",
                  top: "2%",
                  textAlign: "justify",
                  display: "flex",
                  flexDirection: "column",
                  maxHeight:"390px",
                  overflow: "auto"
                }}
              >
                <h2>Healthiness & Lifestyles</h2>
                {/* <p>
                Good nutrition, daily exercise and adequate sleep are the foundations 
                of healthy living. A healthy lifestyle keeps you fit, energetic and at 
                reduced risk for disease. According to WHO, Healthy living is a way of 
                living that helps you enjoy more aspects of your life. It is a way of 
                living that lowers the risk of being seriously ill or dying early. 
                Health is not just about avoiding a disease or illness. It is about 
                physical, mental and social well-being too. When you adopt a healthy 
                lifestyle, you provide a more positive role model for other people in 
                your family, particularly children.
                </p>
                <p>
                  Managing stress in positive ways, instead of through smoking or drinking 
                  alcohol, reduces wear and tear on your body at the molecular level. 
                  For a longer and more comfortable life, you should adopt a healthy life style. </p>
                <Button>More</Button> */}
                  <p style={{margin:"0"}}>{getFirstText()}</p>
              </div>
            </div>
          </div>,
          <div
            style={{
              position: "relative",
              background:
                "transparent linear-gradient(269deg, #FFFFFF 0%, #FFFFFFCC 32%, #7BE9DE74 72%, #66E6D966 77%, #01D6C0 100%)",
              height: "400px",
            }}
          >
            <div>
              <div
                style={{
                  padding: "1rem",
                  maxWidth: "600px",
                  background: "#FFFFFF",
                  boxShadow: "0px 3px 6px #00000029",
                  borderRadius: "40px",
                  position: "absolute",
                  left: "2%",
                  top: "2%",
                  display: "flex",
                  flexDirection: "column",
                  maxHeight:"370px",
                  overflowY: "auto",
                  overflowX:"hidden"
                }}
              >
                <h2>Healthy Food Habits and Nutrition</h2>
                {/* <p>
                Your heart, muscles, bones, immune system and other body systems depend 
                on a continual supply of nutrients for cell growth and metabolism. You
                need to eat  varied diet to get   essential nutrients in the form of 
                protein, vitamins, carbohydrates, minerals and fats. Consume lean meat  
                such as chicken along with legumes, eggs and   nuts for healthy living. 
                Limit your portion size at meals to control your weight and your risk for 
                cardiovascular and other diseases through your lifestyle. If you want to 
                control your weight and reduce the risk of various diseases, you make sure 
                that the diet is nutritious, in addition to limiting portion size.
                </p> */}
                <p style={{margin:"0"}}>{getText()}</p>
                {/* <Button>Learn More</Button> */}
              </div>
              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "10%",
                }}
              >
                <img src="/img/diet.png" alt="lifestyle" height="300px" />
              </div>
            </div>
          </div>,
        ]}
      /> </Col></Row>
      <HealthArticleCard />
      <CovidQuery />
      {/* <HealthQuery /> */}
      <FaqAndTips />
      <LiveSessionCard />
      <AboutUs />
    </div>
  );
};

const Button = styled.button`
  padding: 1rem 2rem;
  font-weight: bold;
  background: #01d6c033 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 2px solid #01d6c0;
  border-radius: 30px;
`;

const healthiness=` Good nutrition, daily exercise and adequate sleep are the foundations 
of healthy living. A healthy lifestyle keeps you fit, energetic and at 
reduced risk for disease. According to WHO, Healthy living is a way of 
living that helps you enjoy more aspects of your life. It is a way of 
living that lowers the risk of being seriously ill or dying early. 
Health is not just about avoiding a disease or illness. It is about 
physical, mental and social well-being too. When you adopt a healthy 
lifestyle, you provide a more positive role model for other people in 
your family, particularly children.


  Managing stress in positive ways, instead of through smoking or drinking 
  alcohol, reduces wear and tear on your body at the molecular level. 
  For a longer and more comfortable life, you should adopt a healthy life style. 
   `

const healthyFood =  ` Your heart, muscles, bones, immune system and other body systems depend 
on a continual supply of nutrients for cell growth and metabolism. You
need to eat  varied diet to get   essential nutrients in the form of 
protein, vitamins, carbohydrates, minerals and fats. Consume lean meat  
such as chicken along with legumes, eggs and   nuts for healthy living. 
Limit your portion size at meals to control your weight and your risk for 
cardiovascular and other diseases through your lifestyle. If you want to 
control your weight and reduce the risk of various diseases, you make sure 
that the diet is nutritious, in addition to limiting portion size.

`;   
   
            
export default Home;
